import { render, staticRenderFns } from "./ConsultaPreFaturaReceita.vue?vue&type=template&id=ce3becc4"
import script from "./ConsultaPreFaturaReceita.vue?vue&type=script&lang=js"
export * from "./ConsultaPreFaturaReceita.vue?vue&type=script&lang=js"
import style0 from "./ConsultaPreFaturaReceita.vue?vue&type=style&index=0&id=ce3becc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports